import { computed, Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  private readonly _activeRequests = signal(0)
  private readonly _message = signal('')
  readonly loading = computed(() => this._activeRequests() > 0)
  readonly message = this._message.asReadonly()

  show(message?: string) {
    this._activeRequests.update((count) => count + 1)
    if (message) {
      this._message.set(message)
    }
  }

  hide() {
    this._activeRequests.update((count) => count - 1)
    if (this._activeRequests() <= 0) {
      this._message.set('')
      this._activeRequests.set(0)
    }
  }
}
